import { api } from '../lib/api';

export interface SignatureTemplate {
  id: string;
  name: string;
  body: string;
  isDefault: boolean;
  isActive: boolean;
  allowDecline: boolean;
  createdAt: number;
  updatedAt: number;
}

export const signatureTemplatesApi = {
  list: (includeInactive = false) =>
    api.get<SignatureTemplate[]>(
      `/api/admin/signature-templates${includeInactive ? '?includeInactive=true' : ''}`
    ),

  get: (id: string) =>
    api.get<SignatureTemplate>(`/api/admin/signature-templates/${id}`),

  create: (data: { name: string; body: string; isDefault?: boolean; allowDecline?: boolean }) =>
    api.post<SignatureTemplate>('/api/admin/signature-templates', data),

  update: (id: string, data: Partial<{ name: string; body: string; isDefault: boolean; isActive: boolean; allowDecline: boolean }>) =>
    api.put<SignatureTemplate>(`/api/admin/signature-templates/${id}`, data),

  delete: (id: string) =>
    api.delete(`/api/admin/signature-templates/${id}`),
};
